import { Close, X } from "@mui/icons-material";
import { Box, Typography, Divider, IconButton, Button } from "@mui/material";
import { ReactNode } from "react";
import { useLivemapStore } from "./useLivemapStore";

interface SidebarProps {
  open: boolean;
  title?: string;
  description?: string;
  children?: ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ open, title, image, description, children }) => {
  if (!open) return null;

  const setSelectedMarker = useLivemapStore((s) => s.setSelectedMarker);
  return (
    <Box
      sx={{
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.paper",
        borderLeft: 1,
        borderColor: "divider",
        boxShadow: 3,
        overflowY: "auto",
      }}
    >
      {true ? (
        <Box
          sx={{
            height: "33%",
            borderBottom: "1px solid #aaa",
            backgroundPosition: "center",
            backgroundSize: "cover",
            minHeight: "300px",
            position: "relative",
          }}
          style={{
            backgroundImage: !!image ? "url(" + import.meta.env.VITE_APP_URL + "/image/" + image + ")" : "none",
            backgroundColor: "#eef",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              right: "20px",
              top: "20px",
              height: "40px",
              width: "40px",
              color: "#444",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "white",
              borderRadius: "10px",
              boxShadow: "1px 1px 3px rgba(0,0,0,0.5)",
              border: "1px solid #aaa",
              cursor: "pointer",
              "&:hover": {
                background: "#eee",
              },
            }}
            onClick={() => setSelectedMarker(null)}
          >
            <Close />
          </Box>
        </Box>
      ) : null}
      {title || description ? (
        <Box p={2} display={"flex"} gap={1}>
          <Box flex={1}>
            {title && <Typography variant="h6">{title}</Typography>}
            {description && (
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            )}
          </Box>
        </Box>
      ) : null}

      <Box p={2} pt={0} flex={1}>
        {children}
      </Box>
    </Box>
  );
};

export default Sidebar;
